import { h } from 'preact';

// Shared backdrop and palette for the long-running-job scenes in the
// Alle besøk admin toolbar (samlefaktura creation, accounting transfers).
// Coordinates are in the scenes' 800x230 viewBox space.

// The scenes are locked to one look (night factory, lit windows) regardless of
// the page's light/dark mode — the picture has its own backdrop, only the
// strip below it follows the page theme via Bootstrap classes.
export const SCENE_PALETTE = {
    backdrop: '#141b24', belt: '#2b3745', beltStripe: '#3d4c5e', roller: '#56687c',
    sheet: '#e9eef4', sheetShadow: 'rgba(0,0,0,0.5)', ink: '#2c3a49', line: '#aeb9c6',
    card: '#2f3d4e', cardStroke: '#56687c', paw: '#4dabf7',
    text: '#a2b8d0', accent: '#ff6b6b', badge: '#20c997',
    wall: '#1b222c', brick: '#222b36', frame: '#3a4756', pane: '#e9b75f', paneDark: '#b8873a',
    pipe: '#3d4b5b', ledge: '#2b3745', stain: 'rgba(0,0,0,0.28)',
    cloud: '#2f3d4e', cloudEdge: '#7f93a8', envelope: '#f3e9c8', envelopeEdge: '#b08d3c',
    machine: '#3a4756', machineDark: '#2b3542', signal: '#20c997',
};

// Tall arched factory window with a 3x4 pane grid and one darker pane for age.
export const FactoryWindow = ({ x, y, p }) => (
    <g class='ci-window'>
        <path d={`M${x} ${y + 24} a35 24 0 0 1 70 0 V${y + 100} H${x} Z`} fill={p.frame} />
        <path d={`M${x + 4} ${y + 24} a31 20 0 0 1 62 0 V${y + 96} H${x + 4} Z`} fill={p.pane} />
        <rect x={x + 22} y={y + 6} width='3' height='90' fill={p.frame} />
        <rect x={x + 45} y={y + 6} width='3' height='90' fill={p.frame} />
        <rect x={x + 4} y={y + 42} width='62' height='3' fill={p.frame} />
        <rect x={x + 4} y={y + 62} width='62' height='3' fill={p.frame} />
        <rect x={x + 4} y={y + 82} width='62' height='3' fill={p.frame} />
        <rect x={x + 48} y={y + 65} width='18' height='17' fill={p.paneDark} />
        <rect x={x + 7} y={y + 45} width='15' height='17' fill={p.paneDark} opacity='0.6' />
        <rect x={x - 4} y={y + 100} width='78' height='5' rx='1' fill={p.frame} />
    </g>
);

// Old brick wall behind the scene: brick pattern, a pipe along the top, the
// windows, a stain streak and the ledge the floor sits against.
const DEFAULT_WINDOW_XS = [80, 215, 520, 655];
export const FactoryWall = ({ p, windowXs = DEFAULT_WINDOW_XS, patternId = 'ci-bricks' }) => (
    <g class='ci-wall'>
        <pattern id={patternId} width='48' height='20' patternUnits='userSpaceOnUse'>
            <rect x='0' y='0' width='23' height='9' rx='1' fill={p.brick} />
            <rect x='25' y='0' width='23' height='9' rx='1' fill={p.brick} />
            <rect x='-12' y='10' width='23' height='9' rx='1' fill={p.brick} />
            <rect x='13' y='10' width='23' height='9' rx='1' fill={p.brick} />
            <rect x='37' y='10' width='23' height='9' rx='1' fill={p.brick} />
        </pattern>
        <rect x='0' y='0' width='800' height='176' fill={p.wall} />
        <rect x='0' y='0' width='800' height='176' fill={`url(#${patternId})`} />
        {/* Pipe with brackets */}
        <rect x='0' y='12' width='800' height='6' rx='3' fill={p.pipe} />
        {[60, 260, 460, 660].map(bx => (
            <rect key={bx} x={bx} y='9' width='6' height='12' rx='1' fill={p.frame} />
        ))}
        {windowXs.map(wx => <FactoryWindow key={wx} x={wx} y={38} p={p} />)}
        {/* Stain streaks */}
        <path d='M236 144 q 6 10 -2 28 q 10 -14 8 -28 Z' fill={p.stain} />
        <path d='M560 144 q 4 8 -1 24 q 7 -10 6 -24 Z' fill={p.stain} />
        {/* Ledge the floor sits against */}
        <rect x='0' y='166' width='800' height='8' fill={p.ledge} />
    </g>
);
